import { render, staticRenderFns } from "./PayRunTransactions.vue?vue&type=template&id=32f1137b&scoped=true&"
import script from "./PayRunTransactions.vue?vue&type=script&lang=js&"
export * from "./PayRunTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PayRunTransactions.vue?vue&type=style&index=0&id=32f1137b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1137b",
  null
  
)

export default component.exports